// ----------------------------------------------------------------------------
// Component: Collection List
// ----------------------------------------------------------------------------
//
// A list of collections
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import SwiperCore, { Swiper, Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper/core';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/swiper-bundle.css';
import './_collection-list.scss';

// Install modules
SwiperCore.use([Swiper, Navigation, Pagination, Scrollbar, A11y, Keyboard]);

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--collection-list").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each collection list slider
        $this.addClass("collection-list-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.collection-list').find(".swiper-button-prev").addClass("collection-list-btn-prev-" + index);
        $this.parents('.collection-list').find(".swiper-button-next").addClass("collection-list-btn-next-" + index);

        // Generate unique btn classes for swiper pagination
        $this.parents('.collection-list').find(".swiper-pagination").addClass("collection-list-swiper-pagination-" + index);


        var swiper = new Swiper(".collection-list-instance-" + index, {
            // Optional parameters
            slidesPerView: 2.25,
            spaceBetween: 8,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 4,
                    spaceBetween: 8
                }
            },

            // // Navigation arrows
            navigation: {
              nextEl: ".collection-list-btn-next-" + index,
              prevEl: ".collection-list-btn-prev-" + index
            },
            pagination: {
                el: ".collection-list-swiper-pagination-" + index,
                type: 'bullets',
                clickable: true,
            }
        });

        swiper.slides.forEach(function(slide, index) {
            let slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', function(e) {
                swiper.slideTo(index);
            })
        });
    });
});
